/**
 * @generated SignedSource<<dbbf9e368ebe9d74c8121a8a49da35d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "GoogleCodeResponse",
    "kind": "LinkedField",
    "name": "googleCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tokenType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "callback1ComponentsGoogleCodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "callback1ComponentsGoogleCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6e298fc427e09e7624a5a38d5ffb8b58",
    "id": null,
    "metadata": {},
    "name": "callback1ComponentsGoogleCodeMutation",
    "operationKind": "mutation",
    "text": "mutation callback1ComponentsGoogleCodeMutation(\n  $request: GoogleCodeRequestInput\n) {\n  googleCode(request: $request) {\n    tokenType\n    accessToken\n    refreshToken\n  }\n}\n"
  }
};
})();

node.hash = "e529b10f42d3b4428836e028d0754ce4";

module.exports = node;
